import { getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
const { AREA } = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatDataByLanguage = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      groupByField,
      entityKey,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const graphColors = getRandomUniqueColor(data.length);
    let labels = [];
    let BGcolors = [];
    let tempData = [];
    let hcData = [];
    data.forEach((elm, index) => {
      labels.push(elm["language_name"]);
      BGcolors.push(graphColors[index]);
      hcData.push([elm.language_name, +elm.article_count]);
      tempData.push(elm["article_count"]);
    });
    const staticLabel = rType.toLowerCase().includes("ccm")
      ? "CCM"
      : rType.toLowerCase().includes("mav")
      ? "MAV"
      : "Count";
    const datasets = [
      {
        label: staticLabel,
        backgroundColor: BGcolors,
        borderColor: BGcolors,
        borderWidth: 1,
        data: tempData,
        barThickness: "flex",
        fill: "start",
        lineTension: 0,
      },
    ];
    return {
      labels,
      datasets,
      hcData,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
      hcData: [],
    };
  }
};
